import React, {Component} from "react";
import "./deptListToolBar.scss";
import {Button} from "antd";
import CmSearchInput from "../../../../../components/CmSearchInput/CmSearchInput";
import BaseComponent from "../../../../../base/BaseComponent";

export default class DeptListToolBar extends BaseComponent {

    render() {
        const {onSearchValueChange, onSearch, searchValue, showEditModal, selectedKeys} = this.props;
        return (
            <div id="DeptListToolBar">
                <div className="DeptListToolBar-left">
                    <Button type="primary" onClick={() => showEditModal()}>添加部门</Button>
                </div>
                <div className="DeptListToolBar-right">
                    <CmSearchInput
                        onSearchValueChange={onSearchValueChange}
                        onSearch={onSearch}
                        searchValue={searchValue}
                        placeholder="请输入部门名称"
                    />
                </div>
            </div>
        );
    }
}

